import { styled } from "@mui/material/styles"

export const Div = styled("div")(() => ({
    display: "flex",
}))
